// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"dae95af7","704":"79505cec"}[chunkId] + ".chunk.js";
};